import React, { useEffect, useState } from 'react';
import './Developer.css';
import baseURL from '../url.js';

export default function Developer() {
  const [name, setName] = useState('Tienda');
  useEffect(()=>{
    const load = async ()=>{
      try{
        const r = await fetch(`${baseURL}/tiendaGet.php`, { cache:'no-store', headers:{ 'Accept':'application/json' } });
        const t = await r.text();
        const d = JSON.parse(t);
        const n = String(d?.tienda?.[0]?.nombre || '').trim();
        if (n) setName(n);
      }catch(_){ }
    };
    load();
    const handler = ()=> load();
    window.addEventListener('config-updated', handler);
    return ()=> window.removeEventListener('config-updated', handler);
  },[]);
  const year = new Date().getFullYear();
  return (
    <div className='Developer'>
      <span className="developer-link">{name}</span>
      <span className="developer-text">© Copyright {year} {name}</span>
    </div>
  );
}
